import { Table, type TableColumnsType } from 'antd'

import { FormattedDate } from '@/components/common/FormattedDate'
import { UserEmailLink } from '@/components/common/UserEmailLink'

import { describeEntry } from '../history'
import { type GpuHistoryEntry, useGpuHistory } from '../hooks/useGpuAdmin'
import { useOffsetPagination } from './offsetPagination'

const historyColumns = (unset: string): TableColumnsType<GpuHistoryEntry> => [
  {
    title: 'When',
    dataIndex: 'changed_at',
    width: 180,
    render: (date: string) => (
      <FormattedDate date={date} fmt="MMM d, yyyy HH:mm" />
    ),
  },
  {
    title: 'Who',
    dataIndex: 'author',
    width: 260,
    render: (author: string) => <UserEmailLink userId={author} />,
  },
  {
    title: 'Change',
    key: 'change',
    render: (_, entry) => describeEntry(entry, unset).join('; ') || '—',
  },
]

export function HistoryTable({ provider }: { provider?: string }) {
  const { args, pagination } = useOffsetPagination()
  const { data, isFetching } = useGpuHistory(provider, args)
  const items = data?.items ?? []

  return (
    <Table<GpuHistoryEntry>
      rowKey="id"
      dataSource={items}
      columns={historyColumns(provider ? 'inherited' : 'default')}
      loading={isFetching}
      pagination={pagination(items.length)}
      size="small"
      locale={{ emptyText: 'No settings changes yet' }}
    />
  )
}
